import React, { useState } from 'react';
import BrowsePrescriptionsMain from './browsePrescriptionMain';
import { withRouter } from 'react-router-dom';

const BrowsePrescriptions = props => {
  let repos;
  if (
    typeof window !== 'undefined' &&
    typeof __INITIAL_DATA__ !== 'undefined'
  ) {
    repos = window.__INITIAL_DATA__;
  } else {
    repos = props.staticContext && props.staticContext.data;
  }
  const [data] = useState(repos);

  return (
    <main>
      <BrowsePrescriptionsMain respData={data?.allData} {...props} />
    </main>
  );
};

export default withRouter(BrowsePrescriptions);
